import { Diamond } from "lucide-react";

const PHRASES = [
  "Custom software",
  "SaaS platforms",
  "Mobile apps",
  "AI copilots",
  "Enterprise GRC",
  "Cyber security GRC",
  "ERP & HRMS",
  "CRM",
  "Warehouse management",
  "Delivery & logistics",
  "Marketplace commerce",
  "PDPL compliance",
  "Cloud & DevOps",
];

function Row({ ariaHidden }) {
  return (
    <div
      aria-hidden={ariaHidden ? "true" : undefined}
      className="flex shrink-0 items-center gap-8 whitespace-nowrap pe-8"
    >
      {PHRASES.map((p, i) => (
        <span key={`${i}-${p}`} className="flex items-center gap-8">
          <span className="text-[13px] font-medium uppercase tracking-[0.18em] text-white/90">
            {p}
          </span>
          <Diamond className="h-2.5 w-2.5 shrink-0 text-wafa-primary" />
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <section
      data-testid="marquee-band"
      className="wafa-marquee relative overflow-hidden border-y border-white/5 bg-wafa-deep"
      aria-label="Capability areas"
    >
      <div className="flex h-16 items-center">
        <div className="wafa-marquee-track flex min-w-max items-center">
          <Row />
          <Row ariaHidden />
        </div>
      </div>
      {/* Soft edge fades so phrases dissolve rather than get chopped. */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 start-0 w-16 bg-gradient-to-r from-wafa-deep to-transparent" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 end-0 w-16 bg-gradient-to-l from-wafa-deep to-transparent" />
    </section>
  );
}
